import * as React from "react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const FeatureCard = ({image, uri, title, subtitle, className = ''}) => {
	const [animateClass, setAnimateClass] = React.useState('');

	const triggerAnimation = () => {
		setAnimateClass('animate');
		setTimeout(() => {
			setAnimateClass('');
		}, 600);
	}

	return (
		<Card 
			className={[`featureCard__card featureCard__card--${className}`, animateClass].join(' ')}
			onMouseEnter={() => triggerAnimation()}
			onMouseLeave={() => triggerAnimation()}
			onFocus={() => triggerAnimation()}
			onBlur={() => triggerAnimation()}
		>
			<div
				className="featureCard__media"
				style={{ backgroundImage: !!image ? `url(${image}?format=webp&quality=100&max-w=380)` : 'none' }}
			/>
			<div className="featureCard__overlay" />
			<CardActionArea className={`featureCard__actionArea featureCard__actionArea--${className}`} href={uri}>
				<CardContent className="featureCard__content">
					{subtitle && (
						<Typography variant="h5" component="div" className="featureCard__cardSubtitle">
							{subtitle}
						</Typography>
					)}
					{title && <Typography
						variant="h3"
						component="div"
						className={`featureCard__cardTitle`}
					>
						{title}
					</Typography>}
				</CardContent>
			</CardActionArea>
		</Card>
	)
}

export default FeatureCard;